const config = {
  apiGateway: {
    REGION: 'us-east-2',
    INTERNAL_API_URL: 'https://56lvzfecbi.execute-api.us-east-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://ukbwye0p9a.execute-api.us-east-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.vale.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.vale.forwoodsafety.com',
    WEBSOCKET: 'wss://ytsci10m9h.execute-api.us-east-2.amazonaws.com/prod'
  },
};

export default config;